// @flow

import * as React from 'react';

import classNames from '@ta/common.classnames';
import { localize, unescaped } from '@ta/common.i18n';
import { featureIsEnabled } from '@ta/common.features';
import { Link } from '@ta/common.routing';
import { escapeHtml } from '@ta/common.text-html';
import { ResponsiveImage } from '@ta/media.image';
import { Icon } from '@ta/styleguide.icon';
import { InteractionLogger } from '@ta/tracking.interactions';

import styles from './DestinationCard.less';

import type {
  FeaturedDestinationsQuery_locations as LocationResult,
  FeaturedDestinationsQuery_sponsoredHome_profile as SponsorResult,
} from './FeaturedDestinationsQuery.gql';

type Props = {|
  slot: number,
  destinationData: LocationResult,
  destinationSponsor?: SponsorResult,
|};

const DestinationCard = ({ slot, destinationData, destinationSponsor }: Props) => {
  const destination = (destinationData: any);
  const sponsor = (destinationSponsor: any);
  const trackingParams = {
    slot,
    locationId: destination?.locationId,
    ...(sponsor && { sponsoredBy: sponsor.id }),
  };
  const cxBrandRefreshPhase0 = featureIsEnabled('cx_brand_refresh_phase0');

  return (
    <div className={styles.candidate}>
      <InteractionLogger>
        {logInteraction => (
          <Link
            href={destination?.route?.url}
            className={classNames(styles.destinationContainer, {
              [styles.isSponsored]: sponsor,
            })}
            onClick={e => {
              logInteraction(e, 'rightRailLocationClick', trackingParams);
            }}
          >
            <ResponsiveImage
              width="100%"
              height="100%"
              borderRadius="4px"
              sources={destination?.thumbnail?.photoSizes}
            />
            <div
              className={classNames(styles.caption, {
                [styles.isSponsored]: sponsor,
                [styles.cx_brand_refresh]: cxBrandRefreshPhase0,
              })}
            >
              <div className={styles.text}>
                <div className={classNames(styles.geoText, { [styles.isSponsored]: sponsor })}>
                  {destination?.additionalNames?.long}
                </div>
                {sponsor && (
                  <div
                    className={styles.sponsorLine}
                    onClick={e => {
                      e.stopPropagation();
                      logInteraction(e, 'userClick', {
                        userId: destinationSponsor?.id,
                        placement: 'HOME_RIGHT_RAIL',
                      });
                    }}
                  >
                    {unescaped(
                      localize('sponsored_by_member', {
                        '0': sponsor?.route?.url || '',
                        '1': classNames(styles.sponsorName, {
                          [styles.verified]: sponsor?.isVerified,
                        }),
                        '2': escapeHtml(sponsor?.displayName),
                      }),
                    )}
                    {/* Sponsored by <a href="{0}" class="{1}">{2}</a> */}
                  </div>
                )}
              </div>
              {!sponsor && !cxBrandRefreshPhase0 && (
                <Icon name="travelers-choice-badge" className={styles.logo} />
              )}
            </div>
          </Link>
        )}
      </InteractionLogger>
    </div>
  );
};

export default DestinationCard;
